const VALID_SUBSCRIPTION_STATUSES = ["active", "trialing", "scheduled_for_cancellation"];
export const SUBSCRIPTION_ACCESS_UPDATED_EVENT = "subscriptionAccessUpdated";

export const isValidSubscriptionStatus = (status) =>
  VALID_SUBSCRIPTION_STATUSES.includes(String(status || "").toLowerCase());

export const isSubscriptionExpired = (subscriptionData) => {
  if (!subscriptionData) return false;
  const expiry = subscriptionData.subscription_end_at || subscriptionData.subscription_cancelled_at;
  if (!expiry) return false;
  try {
    const endDate = new Date(expiry);
    return !isNaN(endDate.getTime()) && endDate.getTime() < Date.now();
  } catch {
    return false;
  }
};

export const hasActiveSubscriptionAccess = (subscriptionData) => {
  if (!subscriptionData) return false;
  const status = String(subscriptionData.subscription_status || "").toLowerCase();
  if (status === "scheduled_for_cancellation") {
    return !isSubscriptionExpired(subscriptionData);
  }
  if (status === "active" || status === "trialing") {
    return !isSubscriptionExpired(subscriptionData);
  }
  return false;
};

export const safeJsonParse = (value, fallback = null) => {
  if (!value || value === "undefined") return fallback;

  try {
    return JSON.parse(value);
  } catch {
    return fallback;
  }
};

export const getSubscriptionDataTypes = (payload) => {
  if (!payload) return [];

  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload.data)) return payload.data;
  if (Array.isArray(payload.subscription_data_types)) return payload.subscription_data_types;
  if (Array.isArray(payload.data?.subscription_data_types)) return payload.data.subscription_data_types;

  return [];
};

export const getStoredSubscriptionDataTypes = () =>
  getSubscriptionDataTypes(safeJsonParse(localStorage.getItem("subscription_data_types")));

export const getStoredIsSubscribed = (userData = null) => {
  const storedValue = safeJsonParse(localStorage.getItem("is_subscribed"));
  return storedValue !== null && storedValue !== undefined
    ? storedValue
    : userData?.is_subscribed || "0";
};

export const updateStoredSubscriptionAccess = (subscriptionData) => {
  if (!subscriptionData) return;

  const hasAccess = hasActiveSubscriptionAccess(subscriptionData);
  localStorage.setItem("is_subscribed", hasAccess ? 1 : 0);
  localStorage.setItem("subscriptionActivePlan", hasAccess ? true : false);

  if (subscriptionData.subscription_end_at) {
    localStorage.setItem("subscription_end_at", JSON.stringify(subscriptionData.subscription_end_at));
  }

  if (subscriptionData.cancellation_requested_at) {
    localStorage.setItem("cancellation_requested_at", JSON.stringify(subscriptionData.cancellation_requested_at));
  } else {
    localStorage.removeItem("cancellation_requested_at");
  }

  const dataTypes = getSubscriptionDataTypes(subscriptionData);
  if (dataTypes.length > 0) {
    localStorage.setItem("subscription_data_types", JSON.stringify(dataTypes));
  }

  const rawUser = localStorage.getItem("user");
  const user = safeJsonParse(rawUser);
  if (user) {
    localStorage.setItem("user", JSON.stringify({ ...user, is_subscribed: hasAccess ? 1 : 0 }));
  }

  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event(SUBSCRIPTION_ACCESS_UPDATED_EVENT));
  }
};
